export const lotPresets = [
    {
        value: 'minus',
        icon: 'IcMinus',
    },
    {
        value: 'plus',
        icon: 'IcPlus',
    }
];

export const amountPercentPresets = [
    {
        value: 2,
        title: '2%',
    }, {
        value: 5,
        title: '5%',
    }, {
        value: 10,
        title: '10%',
    }, {
        value: 20,
        title: '20%',
    }, {
        value: 50,
        title: '50%',
    }, {
        value: 92,
        title: 'All',
    }
];
